import { render, staticRenderFns } from "./ShapeTab.vue?vue&type=template&id=4f3eedb9&scoped=true&"
import script from "./ShapeTab.vue?vue&type=script&lang=js&"
export * from "./ShapeTab.vue?vue&type=script&lang=js&"
import style0 from "./ShapeTab.vue?vue&type=style&index=0&id=4f3eedb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3eedb9",
  null
  
)

export default component.exports